.container {
    min-width: 1000px;
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    height: 100%;
    width: 100%;
    gap: 16px;
}

.sidebar-container {
    width: 400px;
    overflow: auto;
}
